import React  from 'react'
import DropDown from '../dropdown';
import { RoomClasses } from '../../../api/services/next'
import { useMemo } from 'react';

const RoomClassesDropDown = ({...rest}) => {
    const spec = useMemo(() => ({
        }), [] )

    return <DropDown api={RoomClasses.GetRoomClasses} spec={spec} textField="Name" valueField="Id"  {...rest}/>
}

export default RoomClassesDropDown

